import { useEffect, useState } from "react";

export default function AdBanner() {
  const [adLoaded, setAdLoaded] = useState(false);

  useEffect(() => {
    try {
      const adsbygoogle = window.adsbygoogle || [];
      adsbygoogle.push({});
      // Check if ad loaded after 2 seconds
      setTimeout(() => {
        const ads = document.querySelectorAll(".adsbygoogle[data-ad-status]");
        const hasAd = Array.from(ads).some(ad => ad.dataset.adStatus === "filled");
        setAdLoaded(hasAd);
      }, 2000);
    } catch {}
  }, []);

  if (!adLoaded) return null;

  return (
    <div style={{ padding: "8px 16px", overflow: "hidden", background: "#000" }}>
      <ins
        className="adsbygoogle"
        style={{ display: "block", minHeight: 50 }}
        data-ad-client="ca-pub-8414451656952219"
        data-ad-slot="auto"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}